import { FunctionComponent } from 'react'

import { AVAXPillUnit } from '../Dashboard/Cards/AVAXPillUnit'
import { GGPPillUnit } from '../Dashboard/Cards/GGPPillUnit'
import { SEAAVAXPillUnit } from '../Dashboard/Cards/SEAAVAXPillUnit'
import { XGGPPillUnit } from '../Dashboard/Cards/XGGPPillUnit'

import { BigNumberInput } from '@/common/components/Input/BigNumberInput'
import { displayBN } from '@/utils/numberFormatter'

interface Props {
  reward: bigint
  balance: bigint
  token?: string
}

export const RewardForm: FunctionComponent<Props> = ({ balance, reward, token }) => {
  return (
    <>
      <div className="rng-label" style={{ marginBottom: 12 }}>
        Tokens received
      </div>
      <div className="rng-field flex items-center gap-3" style={{ border: 'none' }}>
        <BigNumberInput
          autoFocus
          bnValue={reward}
          className="rng-input min-w-0 flex-1 disabled:cursor-not-allowed"
          disabled
          max={balance}
          min={0n}
          onChange={() => undefined}
          placeholder="0.0"
        />
        {token == 'GGP' && <GGPPillUnit value={null} />}
        {token == 'xGGP' && <XGGPPillUnit value={null} />}
        {token == 'AVAX' && <AVAXPillUnit value={null} />}
        {token == 'seaAVAX' && <SEAAVAXPillUnit value={null} />}
      </div>
      <div className="mt-3 flex justify-end">
        <span style={{ color: 'var(--muted)', fontSize: 13 }}>
          {`Balance ${displayBN(balance)} ${token}`}
        </span>
      </div>
    </>
  )
}
